import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import CheckboxInput        from '../Fields/CheckboxInput';

class CheckboxGroupInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
        };
    }

    render() {
        const checkboxes = this.props.options.map((choice, index) => {
            return(
                <div className="column" key={index}>
                    <CheckboxInput
                        fieldName={this.props.fieldName + '_' + choice.value}
                        question={choice.text}
                        callbackFunction={this.props.callbackFunction}
                    />
                </div>
            );
        });

        return (
            <div className="question-input">
                <div className="row-2 row-constrained">
                    {checkboxes}
                </div>
            </div>
        );
    }
}

CheckboxGroupInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.string.isRequired,
    options:            PropTypes.array.isRequired,
    callbackFunction:   PropTypes.func,
};

export default CheckboxGroupInput;


// WEBPACK FOOTER //
// ./src/components/Fields/CheckboxGroupInput.js